<template>
  <div class="coupon-item" :class="{'disabled':data.status!==0 || !active}">
    <div class="container">
      <p class="f-24 title lh-1 f-w-b">{{data.discountAmount}}<span class="f-14 m-l-5 f-w-600">元</span></p>
      <p class="f-18 f-w-500">{{data.promotionCodeName}}</p>
      <p class="f-14 lh-1">{{data.typeDisplay}} {{data.promotionCodeDesc}}</p>
      <p class="f-14 c-tips m-t-20">有效期至：{{data.effectiveTimeDone}}</p>
      <p class="f-12 c-tips">{{data.useRangeDesc}}</p>
    </div>
    <div class="iconfont icon-wancheng-copy" v-show="data.status == 0 && choiced == 2"></div>
    <div class="used-pin" v-show="data.status == 1">已使用</div>
  </div>
</template>

<script>
export default {
  props:{
    data: {
      type: Object,
      default: ()=>{}
    },
    choiced: {  //选中
      type: Number,
      default: 0
    },
    active: {  //可使用
      type: Boolean,
      default: true
    },
  }
}
</script>


<style lang="scss" scoped>
.coupon-item{
  height:180px;
  background:#FFEDED;
  border-radius: 4px;
  padding:15px 30px;
  color:#313131;
  position: relative;
  margin-bottom: 30px;
  .title{
    margin-bottom:8px;
  }
  p{
    margin-bottom:6px;
  }
  .c-tips{
    color:#707070;
    line-height: 14px;
  }
  .icon-wancheng-copy{
    font-size: 20px;
    color:#E56A69;
    position: absolute;
    top:12px;
    right:12px;
  }
  .used-pin{
    width:62px;
    height:62px;
    border-radius: 32px;
    border:solid 1px #E56A69;
    background-color: #fff;
    position: absolute;
    right:10px;
    bottom:10px;
    font-size:14px;
    color: #E56A69;
    line-height: 60px;
    text-align: center;
    transform: rotate(-25deg);
  }
  &.disabled{
    background:#D2D2D2;
    p{
      color:#707070;
      span{
        color:#707070;
      }
    }
  }
}
</style>
